import type { FeatureItem } from '~/types/feature-type';

export const defaultFeatures: FeatureItem[] = [
  {
    title: 'Automated Script Writing',
    description:
      'AI analyzes your video and generates natural, professional scripts automatically.',
    icon: 'penTool',
    tags: ['Visual Analysis', 'Auto-Scripting', 'Natural Language'],
    mockupType: 'script'
  },
  {
    title: '100+ AI Voices & Languages',
    description:
      'Choose from a vast library of natural-sounding voices in multiple languages and accents.',
    icon: 'globe',
    tags: ['70+ Languages', 'Regional Accents', 'Natural Tone'],
    mockupType: 'voices'
  },
  {
    title: 'Voice Cloning & Custom Uploads',
    description:
      'Clone your own voice or upload custom audio for a personalized touch.',
    icon: 'userCircle',
    tags: ['Voice Cloning', 'Custom Upload', 'Brand Voice'],
    mockupType: 'voiceClone'
  },
  {
    title: 'Professional Timeline Editor',
    description:
      'Fine-tune timing, pacing, and transitions with our intuitive timeline editor.',
    icon: 'slidersHorizontal',
    tags: ['Drag & Drop', 'Precision Edit', 'Visual Timeline'],
    mockupType: 'timeline'
  },
  {
    title: 'Perfect Auto-Sync',
    description:
      'AI automatically syncs voiceover with your video for seamless playback.',
    icon: 'zap',
    tags: ['Smart Sync', 'Beat Matching', 'Frame Perfect'],
    mockupType: 'autoSync'
  },
  {
    title: 'Auto-Generated Captions',
    description:
      'Generate accurate captions and subtitles automatically for accessibility.',
    icon: 'captions',
    tags: ['98% Accuracy', 'Multi-Language', 'SRT Export'],
    mockupType: 'captions'
  },
  {
    title: 'Instant 4K Export',
    description:
      'Export your finished videos in 4K quality, ready to share anywhere.',
    icon: 'film',
    tags: ['4K Support', 'Fast Render', 'Multiple Formats'],
    mockupType: 'export'
  }
];
